module.exports = __webpack_public_path__ + "assets/img/14.8d40e85a.png";